import { render, staticRenderFns } from "./ProductContainerCombobox.vue?vue&type=template&id=7bd38d5c&"
import script from "./ProductContainerCombobox.vue?vue&type=script&lang=ts&"
export * from "./ProductContainerCombobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports